import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';

import { SECTION } from 'entities/navigation';
import { useGetOcpiHubsQuery } from 'entities/ocpi-hub';
import { OCPI_HUB_ROUTES } from 'shared/consts/routes/ocpi-hub';

import { AddButton } from './add-button';

const { label, path } = SECTION['ocpi-hubs'];

export function ConnectedOcpiHubsMenu() {
  const { data, isFetching, error } = useGetOcpiHubsQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.ocpiHubs || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={OCPI_HUB_ROUTES.OCPI_HUBS}
      label={label}
      addButton={<AddButton />}
    />
  );
}
